const TimeReportingProject = {
  AllTimeReportingProjects: "TimeReportingProject.AllTimeReportingProjects",
  TimeReportingProjects: "TimeReportingProject.TimeReportingProjects",
  CreateTimeReportingProject: "TimeReportingProject.CreateTimeReportingProject",
  NewTimeReportingProject: "TimeReportingProject.NewTimeReportingProject",
  SearchTimeReportingProject: "TimeReportingProject.SearchTimeReportingProject",
  TimeReportingProjectName: "TimeReportingProject.TimeReportingProjectName",
  CreatedMessage: "TimeReportingProject.CreatedMessage",
  EditTimeReportingProject: "TimeReportingProject.EditTimeReportingProject",
  Members: "TimeReportingProject.Members",
  CategoryMembers: "TimeReportingProject.CategoryMembers",
  General: "TimeReportingProject.General",
  SaveTimeReportingProject: "TimeReportingProject.SaveTimeReportingProject",
  TimeReportingProjectInformation: "TimeReportingProject.TimeReportingProjectInformation",
  InvoicingInterval_0: "TimeReportingProject.InvoicingInterval_0",
  InvoicingInterval_1: "TimeReportingProject.InvoicingInterval_1",
  InvoicingInterval_2: "TimeReportingProject.InvoicingInterval_2",
  InvoicingInterval_3: "TimeReportingProject.InvoicingInterval_3",
  InvoiceTimeReportDetailLevel_0: "TimeReportingProject.InvoiceTimeReportDetailLevel_0",
  InvoiceTimeReportDetailLevel_1: "TimeReportingProject.InvoiceTimeReportDetailLevel_1",
  InvoicingSettings: "TimeReportingProject.InvoicingSettings",
  Name: "TimeReportingProject.Name",
  HelperTextName: "TimeReportingProject.HelperTextName",
  ManagerName: "TimeReportingProject.ManagerName",
  HelperTextManagerName: "TimeReportingProject.HelperTextManagerName",
  NumberOfMembers: "TimeReportingProject.NumberOfMembers",
  HelperTextNumberOfMembers: "TimeReportingProject.HelperTextNumberOfMembers",
  NumberOfHoursWorked: "TimeReportingProject.NumberOfHoursWorked",
  HelperTextNumberOfHoursWorked: "TimeReportingProject.HelperTextNumberOfHoursWorked",
  Costs: "TimeReportingProject.Costs",
  HelperTextCosts: "TimeReportingProject.HelperTextCosts",
  Margin: "TimeReportingProject.Margin",
  HelperTextMargin: "TimeReportingProject.HelperTextMargin",
  LeftToInvoice: "TimeReportingProject.LeftToInvoice",
  HelperTextLeftToInvoice: "TimeReportingProject.HelperTextLeftToInvoice",
  OnlyWithLeftToInvoice: "TimeReportingProject.OnlyWithLeftToInvoice",
  Invoiced: "TimeReportingProject.Invoiced",
  HelperTextInvoiced: "TimeReportingProject.HelperTextInvoiced",
  TimeReportingProjectNameDescription: "TimeReportingProject.TimeReportingProjectNameDescription",
  ProjectStartDate: "TimeReportingProject.ProjectStartDate",
  ProjectStartDateDescription: "TimeReportingProject.ProjectStartDateDescription",
  ProjectEndDate: "TimeReportingProject.ProjectEndDate",
  ProjectEndDateDescription: "TimeReportingProject.ProjectEndDateDescription",
  ProjectManager: "TimeReportingProject.ProjectManager",
  ProjectManagerDescription: "TimeReportingProject.ProjectManagerDescription",
  ProjectIsActiveDescription: "TimeReportingProject.ProjectIsActiveDescription",
  ProjectDescriptionDescription: "TimeReportingProject.ProjectDescriptionDescription",
  IsInternalProject: "TimeReportingProject.IsInternalProject",
  IsInternalProjectDescription: "TimeReportingProject.IsInternalProjectDescription",
  CustomerInformation: "TimeReportingProject.CustomerInformation",
  CustomerReferencePerson: "TimeReportingProject.CustomerReferencePerson",
  Billingmodel: "TimeReportingProject.Billingmodel",
  BillingmodelDescription: "TimeReportingProject.BillingmodelDescription",
  BillingModel_0: "TimeReportingProject.BillingModel_0",
  BillingModel_1: "TimeReportingProject.BillingModel_1",
  BillingModel_2: "TimeReportingProject.BillingModel_2",
  HourlyRate: "TimeReportingProject.HourlyRate",
  HourlyRateDescription: "TimeReportingProject.HourlyRateDescription",
  ActivateTimeReporting: "TimeReportingProject.ActivateTimeReporting",
  ValidFrom: "TimeReportingProject.ValidFrom",
  ValidTo: "TimeReportingProject.ValidTo",
  CustomerReferencePersonDescription: "TimeReportingProject.CustomerReferencePersonDescription",
  AddMembersDescription: "TimeReportingProject.AddMembersDescription",
  AddMember: "TimeReportingProject.AddMember",
  SaveValueAsReference: "TimeReportingProject.SaveValueAsReference",
  NormalDebitHours: "TimeReportingProject.NormalDebitHours",
  NormalDebitHoursDescription: "TimeReportingProject.NormalDebitHoursDescription",
  NewHourlyRate: "TimeReportingProject.NewHourlyRate",
  NewHourlyRateDescription: "TimeReportingProject.NewHourlyRateDescription",
  ProjectMemberIsActive: "TimeReportingProject.ProjectMemberIsActive",
  ProjectMemberIsInActive: "TimeReportingProject.ProjectMemberIsInActive",
  InvoiceTimeReportDetailLevel: "TimeReportingProject.InvoiceTimeReportDetailLevel",
  InvoiceTimeReportDetailLevelDescription: "TimeReportingProject.InvoiceTimeReportDetailLevelDescription",
  CurrencyDescription: "TimeReportingProject.CurrencyDescription",
  ShortHourDescription: "TimeReportingProject.ShortHourDescription",
  ProjectNameNotUnique: "TimeReportingProject.ProjectNameNotUnique",
  InvoiceTheRemaining: "TimeReportingProject.InvoiceTheRemaining",
  NewHourlyRateFrom: "TimeReportingProject.NewHourlyRateFrom",
  NewHourlyRateFromDescription: "TimeReportingProject.NewHourlyRateFromDescription",
  MemberStartDate: "TimeReportingProject.MemberStartDate",
  MemberStartDateDescription: "TimeReportingProject.MemberStartDateDescription",
  MemberEndDate: "TimeReportingProject.MemberEndDate",
  MemberEndDateDescription: "TimeReportingProject.MemberEndDateDescription",
  AvailablePersonsToInclude: "TimeReportingProject.AvailablePersonsToInclude",
  Information: "TimeReportingProject.Information",
  MemberDatesareNotWithinProjectDates: "TimeReportingProject.MemberDatesareNotWithinProjectDates",
  OneInvoiceDraftSuccessfullyCreated: "TimeReportingProject.OneInvoiceDraftSuccessfullyCreated",
  MultipleInvoiceDraftSuccessfullyCreated: "TimeReportingProject.MultipleInvoiceDraftSuccessfullyCreated",
  NoInvoiceDraftsCreated: "TimeReportingProject.NoInvoiceDraftsCreated",
  IncludeDeletedProjects: "TimeReportingProject.IncludeDeletedProjects",
  IncludeInactiveProjects: "TimeReportingProject.IncludeInactiveProjects",
  ProjectIsInActive: "TimeReportingProject.ProjectIsInActive",
  ProjectIsActive: "TimeReportingProject.ProjectIsActive",
  ProjectIsDeleted: "TimeReportingProject.ProjectIsDeleted",
  ProjectIsNotStarted: "TimeReportingProject.ProjectIsNotStarted",
  ProjectActiveStateHelperText: "TimeReportingProject.ProjectActiveStateHelperText",
  DimensionAlreadyExists: "TimeReportingProject.DimensionAlreadyExists",
  ProjectInactivated: "TimeReportingProject.ProjectInactivated",
  Inactivate: "TimeReportingProject.Inactivate",
  ProjectDeleted: "TimeReportingProject.ProjectDeleted",
  Delete: "TimeReportingProject.Delete",
  WarningMessageProjectDeletion: "TimeReportingProject.WarningMessageProjectDeletion",
  WarningMessageUnInvoicedProjectTimeProjectDeletion: "TimeReportingProject.WarningMessageUnInvoicedProjectTimeProjectDeletion",
  BundledInvoice: "TimeReportingProject.BundledInvoice",
  BundledInvoiceDescription: "TimeReportingProject.BundledInvoiceDescription",
  ActivateMember: "TimeReportingProject.ActivateMember",
  InactivateMember: "TimeReportingProject.InactivateMember",
  SellerTagActivateOnInvoice: "TimeReportingProject.SellerTagActivateOnInvoice",
  SellerTagActivateOnInvoiceDescription: "TimeReportingProject.SellerTagActivateOnInvoiceDescription",
  ProceedWithoutSellerTag: "TimeReportingProject.ProceedWithoutSellerTag",
  ProceedWithoutSellerTagDescription: "TimeReportingProject.ProceedWithoutSellerTagDescription",
  ProjectCategories: "TimeReportingProject.ProjectCategories",
  Standard: "TimeReportingProject.Standard",
  ProjectCategoriesDescription: "TimeReportingProject.ProjectCategoriesDescription",
  ProjectCategoriesExplanationDescription: "TimeReportingProject.ProjectCategoriesExplanationDescription",
  ProjectCategoryNumberOfMembers: "TimeReportingProject.ProjectCategoryNumberOfMembers",
  ProjectCategoryNumberOfMember: "TimeReportingProject.ProjectCategoryNumberOfMember",
  ProjectCategoryNumberOfMembersAll: "TimeReportingProject.ProjectCategoryNumberOfMembersAll",
  SetAsStandardCategory: "TimeReportingProject.SetAsStandardCategory",
  CategoryInvoiceType_0: "TimeReportingProject.CategoryInvoiceType_0",
  CategoryInvoiceType_1: "TimeReportingProject.CategoryInvoiceType_1",
  CategoryInvoiceType_2: "TimeReportingProject.CategoryInvoiceType_2",
  CategoryInvoiceType_3: "TimeReportingProject.CategoryInvoiceType_3",
  CategoryName: "TimeReportingProject.CategoryName",
  CategoryCommonHourlyRate: "TimeReportingProject.CategoryCommonHourlyRate",
  CategoryCommonHourlyRateControlLabel: "TimeReportingProject.CategoryCommonHourlyRateControlLabel",
  CategoryCommonDescriptionText: "TimeReportingProject.CategoryCommonDescriptionText",
  ChangeIndivudalRates: "TimeReportingProject.ChangeIndivudalRates",
  IncludeAll: "TimeReportingProject.IncludeAll",
  Rates: "TimeReportingProject.Rates",
  CategoryBillingModel: "TimeReportingProject.CategoryBillingModel",
  ProjectMemberAccesToCategory: "TimeReportingProject.ProjectMemberAccesToCategory",
  QueuedRateChanges: "TimeReportingProject.QueuedRateChanges",
  Current: "TimeReportingProject.Current",
  AddedHourlyRateAlreadyExistsForMonth: "TimeReportingProject.AddedHourlyRateAlreadyExistsForMonth",
  ChangeAllMemberRates: "TimeReportingProject.ChangeAllMemberRates",
  ChangeAllCategoryRates: "TimeReportingProject.ChangeAllCategoryRates",
  ChangesApplyFromTheFirstInTheMonth: "TimeReportingProject.ChangesApplyFromTheFirstInTheMonth",
  SetWhichCategoriesTheProjectMemberShouldHaveAccessTo: "TimeReportingProject.SetWhichCategoriesTheProjectMemberShouldHaveAccessTo",
  NoCategories: "TimeReportingProject.NoCategories",
  AccessUntilEndOf: "TimeReportingProject.AccessUntilEndOf",
  CategoryAlreadyExists: "TimeReportingProject.CategoryAlreadyExists",
  InactivateCategory: "TimeReportingProject.InactivateCategory",
  ActivateCategory: "TimeReportingProject.ActivateCategory",
  OnlyOneFixedPriceMinusDeviationForPersonProject: "TimeReportingProject.OnlyOneFixedPriceMinusDeviationForPersonProject",
  NormalTime: "TimeReportingProject.NormalTime",
  Category: "TimeReportingProject.Category",
  IncludeAttachmentsOnInvoice: "TimeReportingProject.IncludeAttachmentsOnInvoice",
  IncludeAttachmentsOnInvoiceDescription: "TimeReportingProject.IncludeAttachmentsOnInvoiceDescription",
  IncludeCommentsOnAttachments: "TimeReportingProject.IncludeCommentsOnAttachments",
  IncludeCommentsOnAttachmentsDescription: "TimeReportingProject.IncludeCommentsOnAttachmentsDescription",
  PeriodisationEnabled: "TimeReportingProject.PeriodisationEnabled",
  PeriodisationEnabledDescription: "TimeReportingProject.PeriodisationEnabledDescription",
  Details: "TimeReportingProject.Details",
  ExportDetailedReport: "TimeReportingProject.ExportDetailedReport",
  TimeReportsExported: "TimeReportingProject.TimeReportsExported",
  PartiallyCreditedInvoiceAmount: "TimeReportingProject.PartiallyCreditedInvoiceAmount",
  CreditingState_1: "TimeReportingProject.CreditingState_1",
  CreditingState_2: "TimeReportingProject.CreditingState_2",
  ShouldEffectSalary: "TimeReportingProject.ShouldEffectSalary",
  ShouldEffectSalaryDescription: "TimeReportingProject.ShouldEffectSalaryDescription",
  DeviationType: "TimeReportingProject.DeviationType",
  AdjustPreviouslyReportedTime: "TimeReportingProject.AdjustPreviouslyReportedTime",
  AdjustPreviouslyReportedTimeDescription: "TimeReportingProject.AdjustPreviouslyReportedTimeDescription",
  DeviationTypeDescription: "TimeReportingProject.DeviationTypeDescription",
  MarkAsInvoiced: "TimeReportingProject.MarkAsInvoiced",
  ChooseInvoice: "TimeReportingProject.ChooseInvoice",
  ChooseInvoiceDescription: "TimeReportingProject.ChooseInvoiceDescription",
  DivideAmount: "TimeReportingProject.DivideAmount",
  DivideAmountDescription: "TimeReportingProject.DivideAmountDescription",
  InvoiceConnectedSuccessfully: "TimeReportingProject.InvoiceConnectedSuccessfully",
  SearchByInvoiceNumber: "TimeReportingProject.SearchByInvoiceNumber",
  DialogSummaryText: "TimeReportingProject.DialogSummaryText",
  DividedMoreThanInvoiceAmount: "TimeReportingProject.DividedMoreThanInvoiceAmount",
  SelfBilling: "TimeReportingProject.SelfBilling",
  SelfBillingToSubcontractor: "TimeReportingProject.SelfBillingToSubcontractor",
  SelfBillingToSubcontractorDescription: "TimeReportingProject.SelfBillingToSubcontractorDescription",
  SelfBillingOrgNumberDescription: "TimeReportingProject.SelfBillingOrgNumberDescription",
  SelfBillingEmailDescription: "TimeReportingProject.SelfBillingEmailDescription",
  SelfBillingPaymentMethod: "TimeReportingProject.SelfBillingPaymentMethod",
  SelfBillingPaymentMethodDescription: "TimeReportingProject.SelfBillingPaymentMethodDescription",
  SelfBillingPaymentMethodBankgiro: "TimeReportingProject.SelfBillingPaymentMethodBankgiro",
  SelfBillingPaymentMethodIBAN: "TimeReportingProject.SelfBillingPaymentMethodIBAN",
  SelfBillingPaymentMethodBankTransfer: "TimeReportingProject.SelfBillingPaymentMethodBankTransfer",
  SelfBillingPaymentMethodPlusgiro: "TimeReportingProject.SelfBillingPaymentMethodPlusgiro",
  SelfBillingPlusgiro: "TimeReportingProject.SelfBillingPlusgiro",
  SelfBillingBankgiro: "TimeReportingProject.SelfBillingBankgiro",
  SelfBillingPaymentTerms10Days: "TimeReportingProject.SelfBillingPaymentTerms10Days",
  SelfBillingPaymentTerms14Days: "TimeReportingProject.SelfBillingPaymentTerms14Days",
  SelfBillingPaymentTerms30Days: "TimeReportingProject.SelfBillingPaymentTerms30Days",
  SelfBillingPaymentTermsWhenEndCustomerPaid: "TimeReportingProject.SelfBillingPaymentTermsWhenEndCustomerPaid",
  SelfBillingCalculationMethod: "TimeReportingProject.SelfBillingCalculationMethod",
  SelfBillingCalculationMethodDescription: "TimeReportingProject.SelfBillingCalculationMethodDescription",
  SelfBillingCalculationMethodPercent: "TimeReportingProject.SelfBillingCalculationMethodPercent",
  SelfBillingCalculationMethodHourlyRate: "TimeReportingProject.SelfBillingCalculationMethodHourlyRate",
  SelfBillingCalculationMethodFixedPrice: "TimeReportingProject.SelfBillingCalculationMethodFixedPrice",
  SelfBillingPercentage: "TimeReportingProject.SelfBillingPercentage",
  SelfBillingPercentageDescription: "TimeReportingProject.SelfBillingPercentageDescription",
  SelfBillingHourlyRate: "TimeReportingProject.SelfBillingHourlyRate",
  SelfBillingHourlyRateDescription: "TimeReportingProject.SelfBillingHourlyRateDescription",
  SelfBillingQueuedRateChanges: "TimeReportingProject.SelfBillingQueuedRateChanges",
  SelfBillingMissingHourlyRateForCategory: "TimeReportingProject.SelfBillingMissingHourlyRateForCategory",
  SelfBillingMissingHourlyRateTooltip: "TimeReportingProject.SelfBillingMissingHourlyRateTooltip",
  SelfBillingHourlyBilling: "TimeReportingProject.SelfBillingHourlyBilling",
  SelfBillingOvertime: "TimeReportingProject.SelfBillingOvertime",
  SelfBillingMonthlyCost: "TimeReportingProject.SelfBillingMonthlyCost",
  SelfBillingMonthlyCostDescription: "TimeReportingProject.SelfBillingMonthlyCostDescription",
  }
export default TimeReportingProject;